import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_primary = _resolveComponent("button-primary")!
  const _component_form_template = _resolveComponent("form-template")!
  const _component_page_template = _resolveComponent("page-template")!

  return (_openBlock(), _createBlock(_component_page_template, null, {
    default: _withCtx(() => [
      _createVNode(_component_form_template, null, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("BusyPage_title")), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("BusyPage_description1")), 1),
            _hoisted_1,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("BusyPage_description2")), 1)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_button_primary, {
              classes: "w-100",
              onClick: _ctx.reload,
              name: _ctx.$t('Reload')
            }, null, 8, ["onClick", "name"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}